import { Directive, Output, HostBinding, HostListener, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appDragAndDrop]'
})
export class DragAndDropDirective {
  @Output() fileDropped = new EventEmitter<FileList>();

  @HostBinding('style.background-color') background = '#fff';

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    // any type used to work on Safari
    event.preventDefault();
    event.stopPropagation();
    this.background = '#f8f8f8';
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    // any type used to work on Safari
    event.preventDefault();
    event.stopPropagation();
    this.background = '#fff';
  }

  @HostListener('drop', ['$event']) ondrop(event: any) {
    // any type used to work on Safari
    event.preventDefault();
    event.stopPropagation();
    this.background = '#fff';
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
